import React from 'react';
import { useLanguage } from '@contexts/LanguageContext';
import Icon from '@components/Icon/Icon';
import { formatDate, getReservationDurationText } from '@utils/dateUtils';

export const BorrowingTimeline = ({ borrowing, currentLanguage }) => {
    const { t } = useLanguage();

    const formatDateWithLocale = (dateString, includeTime = true) => {
        return formatDate(dateString, includeTime, currentLanguage);
    };

    const getReservationDurationTextWithLocale = (reservedFrom, reservedUntil) => {
        return getReservationDurationText(reservedFrom, reservedUntil, t, currentLanguage);
    };

    return (
        <div className="timeline-section">
            <h3>{t('borrowingView.timelineTitle')}</h3>
            <div className="timeline">
                {borrowing.reserved_from && (
                    <div className="timeline-item completed">
                        <div className="timeline-icon">
                            <Icon icon="bookmark" />
                        </div>
                        <div className="timeline-content">
                            <h4>{t('borrowingView.timeline.reserved')}</h4>
                            <p>{formatDateWithLocale(borrowing.reserved_from)}</p>
                            {borrowing.reserved_until && (
                                <p className="timeline-duration">
                                    {t('borrowingView.reservationDuration')}: {getReservationDurationTextWithLocale(borrowing.reserved_from, borrowing.reserved_until)}
                                </p>
                            )}
                            {borrowing.user && (
                                <p className="timeline-user">
                                    {t('borrowingView.timeline.by')} {borrowing.user.name || borrowing.user.email}
                                </p>
                            )}
                        </div>
                    </div>
                )}

                {borrowing.borrowed_at && (
                    <div className="timeline-item completed">
                        <div className="timeline-icon">
                            <Icon icon="calendar" />
                        </div>
                        <div className="timeline-content">
                            <h4>{t('borrowingView.timeline.borrowed')}</h4>
                            <p>{formatDateWithLocale(borrowing.borrowed_at)}</p>
                            {borrowing.user && (
                                <p className="timeline-user">
                                    {t('borrowingView.timeline.by')} {borrowing.user.name || borrowing.user.email}
                                </p>
                            )}
                        </div>
                    </div>
                )}

                {borrowing.expected_return_at && (
                    <div className={`timeline-item ${borrowing.returned_at ? 'completed' : 'pending'}`}>
                        <div className="timeline-icon">
                            <Icon icon={borrowing.returned_at ? "check" : "clock"} />
                        </div>
                        <div className="timeline-content">
                            <h4>
                                {borrowing.returned_at
                                    ? t('borrowingView.timeline.returned')
                                    : t('borrowingView.timeline.expectedReturn')
                                }
                            </h4>
                            <p>
                                {borrowing.returned_at
                                    ? formatDateWithLocale(borrowing.returned_at)
                                    : formatDateWithLocale(borrowing.expected_return_at)
                                }
                            </p>
                            {!borrowing.returned_at && borrowing.status === 'overdue' && (
                                <p className="timeline-overdue">
                                    {t('borrowingView.timeline.overdue')}
                                </p>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
